import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { FoodsIllustrations } from "@foodpilot/foods";

const PaymentNoActiveSubscriptionAlert = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                backgroundColor: "white",
                border: "1px solid #E0DEDD",
                borderRadius: theme.spacing(2),
                p: theme.spacing(4),
            }}
        >
            <Stack direction="row" gap={theme.spacing(3)} alignItems="center">
                {/* Lock Icon */}
                <FoodsIllustrations illustration="defaultIllustration" />

                {/* Texts */}
                <Stack gap={theme.spacing(1)}>
                    <Typography
                        sx={{
                            fontFamily: "Montserrat",
                            fontWeight: 700,
                            fontSize: "16px",
                            lineHeight: 1.6,
                        }}
                    >
                        {t(
                            "companySettings.subscription.no_active_subscription",
                            "You don't have an active subscription.",
                        )}
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: "Montserrat",
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: 1.6,
                        }}
                    >
                        {t(
                            "companySettings.subscription.unlock_features",
                            "Unlock all platform features by subscribing to one of our plans.",
                        )}
                    </Typography>
                </Stack>
            </Stack>
        </Box>
    );
};

export default PaymentNoActiveSubscriptionAlert;
